document.addEventListener('DOMContentLoaded', function () {
  const clickableDivs = document.querySelectorAll('.clickable');
  console.log('.slideshow__text-wrapper loaded')

  clickableDivs.forEach(div => {
    div.addEventListener('click', function () {
      console.log('.slideshow__text-wrapper clicked')
      const href = this.getAttribute('data-href');
      if (href) {
        window.location.href = href;
      }
    });

    div.addEventListener('keydown', function (e) {
      const href = this.getAttribute('data-href');
      if ((e.key === 'Enter' || e.key === ' ') && href) {
        window.location.href = href;
      }
    });
  });
});
